import { User } from '@/slices/account/account.types';

import {
  BaseCompany,
  BaseCompanyPayload,
  CompanyLicense,
} from '@/types/companies.types';
import { StandardItemLink } from '@/types/generic.types';

export enum StructureTypeEnum {
  Group = 'Group',
  Site = 'Site',
  Holding = 'Holding',
  Branch = 'Branch',
  Subsidiary = 'Subsidiary',
  BusinessUnit = 'BusinessUnit',
}

export interface OrganizationalUnit extends BaseCompany {
  structureType: StructureTypeEnum | null;
  enterpriseId: string | null;
  subsidiaries: OrganizationalUnit[];
}

export interface Enterprise extends BaseCompany {
  structureType: StructureTypeEnum | null;
  organizationalUnits: OrganizationalUnit[];
  isTemplate: boolean;
  isPublic: boolean;
  ownedBy: string | null;
  hasLicense: boolean;
  createdAt: string;
  archivedDate: string | null;
  createdBy: string | null;
  license: CompanyLicense | null;
  customStandards: StandardItemLink[];
}

export type HydratedEnterprise = Enterprise & {
  createdByResolved: User | null;
};

export interface EnterpriseManager {
  id: string;
  firstName: string;
  lastName: string;
}

export interface OrganizationalUnitPayload extends BaseCompanyPayload {
  structureType: string | null;
  enterpriseId: string | null;
  subsidiaries: OrganizationalUnitPayload[] | null;
}

export interface EnterprisePayload extends BaseCompanyPayload {
  structureType: string | null;
  organizationalUnits?: OrganizationalUnitPayload[] | null;
  isTemplate: boolean;
  isPublic: boolean;
  ownedBy: string | null;
  createdAt: string;
  archivedDate: string | null;
  createdBy: string | null;
  license: CompanyLicense | null;
  customStandards: StandardItemLink[];
}

export interface EnterpriseManagersPayload {
  managers?: EnterpriseManager[] | null;
}

export interface EnterprisesPayload {
  enterprises?: EnterprisePayload[] | null;
}
